import {
  postResearchAdjudicationDrafts,
  ResearchAdjudicationDraftApi,
} from '@/api/researchMode'
import { useState } from 'react'
import { toast } from 'sonner'

export interface ResearchDraftPrefill {
  adjudication: string
}

export function useResearchAdjudicationDrafts(roomId: string) {
  const [draftByDecisionId, setDraftByDecisionId] = useState<
    Record<string, ResearchDraftPrefill>
  >({})
  const [isGeneratingDrafts, setIsGeneratingDrafts] = useState(false)

  const mergeDrafts = (drafts: ResearchAdjudicationDraftApi[]) => {
    setDraftByDecisionId((previous) => {
      const next = { ...previous }
      for (const draft of drafts) {
        if (!draft.suggested_adjudication) continue
        next[String(draft.student_decision_id)] = {
          adjudication: draft.suggested_adjudication,
        }
      }
      return next
    })
  }

  const generateDraftsForDecisionIds = async (
    decisionIds: string[] | number[],
    successMessage?: string
  ) => {
    if (!roomId) return [] as ResearchAdjudicationDraftApi[]
    if (!decisionIds.length) {
      toast.message('No pending decisions to generate drafts for')
      return [] as ResearchAdjudicationDraftApi[]
    }
    setIsGeneratingDrafts(true)
    try {
      const response = await postResearchAdjudicationDrafts(roomId, {
        decision_ids: decisionIds.map((decisionId) => Number(decisionId)),
      })
      mergeDrafts(response.drafts || [])
      toast.success(successMessage || 'AI drafts generated')
      return response.drafts || []
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'Failed to generate drafts')
      return []
    } finally {
      setIsGeneratingDrafts(false)
    }
  }

  return {
    draftByDecisionId,
    isGeneratingDrafts,
    generateDraftsForDecisionIds,
  }
}
